


























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  MiscellaneousComparisonTitleDetails,
  MonthComparisonTitleDetails,
  SummaryAnalysis,
  SummaryAnalysisOutput,
} from '@/models/swine/analysis.model';
import BasicBarChart from '../reports/BasicBarChart.vue';
import GraphToggle from './GraphToggle.vue';
import LungLesionScoreAnalysisTable from './LungLesionScoreAnalysisTable.vue';
import AnalysisLayout from '@/components/swine/layout/AnalysisLayout.vue';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
(pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
import { convertDateToDDMMYYYYWithSlashes } from '@/utils/moment';
import {
  ELANCO_LOGO_IMAGE,
  LUNG_LESION_IMAGE,
  LUNG_LESION_SCORE_SUMMARY_COLORS,
} from '@/utils/analysisPdfMake';
import { TableCell, TDocumentDefinitions } from 'pdfmake/interfaces';
import { addDecimalPointToNumbers } from '@/utils/formats';
@Component({
  components: {
    BasicBarChart,
    GraphToggle,
    LungLesionScoreAnalysisTable,
    AnalysisLayout,
  },
})
export default class LungLesionScoreAnalysisComponent extends Vue {
  @Prop({})
  chartData!: Chart.ChartData;

  @Prop({})
  options!: Chart.ChartOptions;

  @Prop({})
  analysisResponse!: SummaryAnalysisOutput;

  @Prop({})
  comparisonTitle!: MiscellaneousComparisonTitleDetails &
    MonthComparisonTitleDetails;

  @Prop({})
  isMiscellaneous!: boolean;

  @Prop({ required: true })
  isCurrentRoleViewer!: boolean;

  removeNumberOfLungsExamined = false;

  updateRemoveNumberOfLungsExamined(value: boolean) {
    this.removeNumberOfLungsExamined = value;
  }

  @Emit(`changeChart`)
  changeGraph(value: boolean) {
    return value;
  }

  generateChartImage() {
    const currentDocument: HTMLCanvasElement | null = document.getElementById(
      'bar-chart',
    ) as HTMLCanvasElement;
    if (currentDocument) {
      return currentDocument.toDataURL();
    }
    return '';
  }

  generatePDFBodyTitle() {
    let generatedTitle = `Comparison of ${this.comparisonTitle.selectedOption} by ${this.comparisonTitle.selectedComparison} from ${this.comparisonTitle.startDate} and ${this.comparisonTitle.endDate} `;
    if (this.comparisonTitle.queries) {
      generatedTitle += `between `;
      this.comparisonTitle.queries.forEach((detail, index) => {
        if (index < this.comparisonTitle.queries.length - 1) {
          generatedTitle += `${detail}, `;
        } else {
          generatedTitle += `and ${detail}.`;
        }
      });
    }

    if (this.comparisonTitle.farmUnitCodeName) {
      generatedTitle += `on ${this.comparisonTitle.farmUnitCodeName}.`;
    }

    return generatedTitle;
  }

  generatePDFTableHeader(): TableCell[] {
    return [
      {
        text: '',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.LIGHT_GREY.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.LIGHT_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'No. of Lungs Examined',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'Bronchopneumonia Lungs (%)',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.GREEN.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.LIGHT_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'Avg. Affected Surface out of Lungs with Active Pneumonia (%)',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.GREEN_DARK.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.GREEN_DARK.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'No. of Lungs Examined',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'Cranial Pleurisy (P1) (%)',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.YELLOW_LIGHT.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.YELLOW_LIGHT.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'Dorsocaudal Pleurisy (P2+P3+P4) (%)',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.YELLOW_DARK.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.YELLOW_DARK.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'No. of Lungs Examined',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'Abscess (%)',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.RED_LIGHT.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.RED_LIGHT.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'No. of Lungs Examined',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'Scarring (%)',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.RED_DARK.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.RED_DARK.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'No. of Lungs Examined',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
      {
        text: 'Pericarditis (%)',
        fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.BLUE.BACKGROUND,
        color: LUNG_LESION_SCORE_SUMMARY_COLORS.BLUE.TEXT,
        fontSize: 9,
        border: [false, false, false, true],
        bold: true,
      },
    ];
  }

  generatePDFTableContent(): TableCell[][] {
    if (this.analysisResponse) {
      const tableData: SummaryAnalysis[] = [];
      if (this.analysisResponse.farmUnits) {
        tableData.push(...this.analysisResponse.farmUnits);
      }
      if (this.analysisResponse.industryAverages) {
        tableData.push(...this.analysisResponse.industryAverages);
      }
      if (this.analysisResponse.individualReports) {
        tableData.push(...this.analysisResponse.individualReports);
      }

      const pdfTableDetails = tableData.map((data) => {
        return [
          {
            text: data.identifier,
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.LIGHT_GREY.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.LIGHT_GREY.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.numberOfLungsExaminedForBronchopneumoniaScore,
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.bronchopneumoniaLungs
              ? addDecimalPointToNumbers(data.bronchopneumoniaLungs)
              : addDecimalPointToNumbers(0),
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.GREEN.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.GREEN.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.averageAffectedLungsSurfaceWithActivePneumonia
              ? addDecimalPointToNumbers(
                  data.averageAffectedLungsSurfaceWithActivePneumonia,
                )
              : addDecimalPointToNumbers(0),
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.GREEN_DARK.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.GREEN_DARK.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.numberOfLungsExaminedForPleuritis,
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.cranialPleurisy
              ? addDecimalPointToNumbers(data.cranialPleurisy)
              : addDecimalPointToNumbers(0),
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.YELLOW_LIGHT.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.YELLOW_LIGHT.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.dorsocaudalPleurisy
              ? addDecimalPointToNumbers(data.dorsocaudalPleurisy)
              : addDecimalPointToNumbers(0),
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.YELLOW_DARK.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.YELLOW_DARK.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.numberOfLungsExaminedForAbscess,
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.abscess
              ? addDecimalPointToNumbers(data.abscess)
              : addDecimalPointToNumbers(0),
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.RED_LIGHT.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.RED_LIGHT.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.numberOfLungsExaminedForScarring,
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.scarring
              ? addDecimalPointToNumbers(data.scarring)
              : addDecimalPointToNumbers(0),
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.RED_DARK.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.RED_DARK.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.numberOfLungsExaminedForPericarditis,
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.DARK_GREY.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
          {
            text: data.pericarditis
              ? addDecimalPointToNumbers(data.pericarditis)
              : addDecimalPointToNumbers(0),
            fillColor: LUNG_LESION_SCORE_SUMMARY_COLORS.BLUE.BACKGROUND,
            color: LUNG_LESION_SCORE_SUMMARY_COLORS.BLUE.TEXT,
            fontSize: 10,
            border: [false, false, false, true],
            bold: true,
          },
        ];
      });
      return pdfTableDetails;
    }
    return [[]];
  }

  generatePdfTable() {
    const pdfTable = [this.generatePDFTableHeader()];
    const details = this.generatePDFTableContent();

    if (details) {
      details.forEach((item) => {
        if (item) {
          pdfTable.push(item);
        }
      });
    }
    return pdfTable;
  }

  generatePDF() {
    try {
      const imgElancoLogo = ELANCO_LOGO_IMAGE;
      const imgLungLesion = LUNG_LESION_IMAGE;
      const headerTitle = 'Lung Lesion Scoring Analysis';
      pdfMake.tableLayouts = {
        headerLayout: {
          hLineColor: function () {
            return '#dbdbdb';
          },
          vLineColor: function () {
            return '';
          },
          paddingLeft: function () {
            return 0;
          },
          paddingRight: function () {
            return 0;
          },
          paddingTop: function () {
            return 0;
          },
          paddingBottom: function () {
            return 0;
          },
        },
        tableLayout: {
          hLineColor: function () {
            return '#dbdbdb';
          },
          vLineColor: function () {
            return '';
          },
        },
      };

      const docDefinition: TDocumentDefinitions = {
        pageOrientation: 'landscape',
        content: [
          {
            table: {
              widths: ['auto', 'auto', '*'],
              body: [
                [
                  {
                    svg: imgElancoLogo,
                    width: 100,
                    margin: [0, 0, 0, 0],
                    border: [false, false, false, true],
                  },
                  {
                    svg: imgLungLesion,
                    width: 50,
                    margin: [120, 0, 0, 0],
                    border: [false, false, false, true],
                  },
                  {
                    text: headerTitle,
                    color: '#333',
                    bold: true,
                    fontSize: 20,
                    margin: [17, 17, 0, 17],
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
            layout: 'headerLayout',
          },
          {
            text: this.generatePDFBodyTitle(),
            bold: true,
            fontSize: 14,
            margin: [0, 30, 0, 30],
          },
          {
            columns: [
              {
                width: 741,
                image: this.generateChartImage(),
              },
            ],
            pageBreak: 'after',
          },
          {
            table: {
              widths: ['auto', 'auto', '*'],
              body: [
                [
                  {
                    svg: imgElancoLogo,
                    width: 100,
                    margin: [0, 0, 0, 0],
                    border: [false, false, false, true],
                  },
                  {
                    svg: imgLungLesion,
                    width: 50,
                    margin: [120, 0, 0, 0],
                    border: [false, false, false, true],
                  },
                  {
                    text: headerTitle,
                    color: '#333',
                    bold: true,
                    fontSize: 20,
                    margin: [17, 17, 0, 17],
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
            layout: 'headerLayout',
          },
          {
            text: this.generatePDFBodyTitle(),
            bold: true,
            fontSize: 14,
            margin: [0, 30, 0, 30],
          },
          {
            table: {
              widths: [
                50,
                56,
                'auto',
                '*',
                56,
                'auto',
                'auto',
                56,
                'auto',
                56,
                'auto',
                56,
                'auto',
              ],
              body: this.generatePdfTable(),
            },
            layout: 'tableLayout',
          },
        ],
        footer: {
          columns: [
            {
              text: `Exported on ${convertDateToDDMMYYYYWithSlashes(
                new Date(),
              )}`,
              fontSize: 10,
              color: '#8e8e8e',
              margin: [30, 0, 0, 0],
            },
          ],
        },
      };
      pdfMake
        .createPdf(docDefinition)
        .download('lung-lesion-scoring-analysis.pdf');
    } catch (error) {
      console.error(error);
    }
  }
}
